import React, { useState, useMemo, useRef, useEffect, useCallback } from 'react';
import List from 'react-virtualized/dist/es/List';
import MemberRow from './MemberRow';
import styles from './FlatMemberView.module.scss';
const ROW_HEIGHT = 32;
const OVERSCAN = 10;
const FlatMemberView = ({ members }) => {
    const [keyword, setKeyword] = useState('');
    const listRef = useRef(null);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    useEffect(() => {
        const el = listRef.current;
        if (!el)
            return;
        const observer = new ResizeObserver(entries => {
            const { width, height } = entries[0].contentRect;
            setDimensions({ width, height });
        });
        observer.observe(el);
        return () => observer.disconnect();
    }, []);
    const filteredAndSorted = useMemo(() => {
        let result = members;
        if (keyword.trim()) {
            const kw = keyword.toLowerCase().trim();
            result = result.filter(m => m.name.toLowerCase().includes(kw) || m.email.toLowerCase().includes(kw));
        }
        return [...result].sort((a, b) => a.name.localeCompare(b.name, 'zh-CN'));
    }, [members, keyword]);
    const rowRenderer = useCallback(({ index, key, style }) => (React.createElement("div", { key: key, style: style },
        React.createElement(MemberRow, { member: filteredAndSorted[index] }))), [filteredAndSorted]);
    return (React.createElement("div", { className: styles.container },
        React.createElement("input", { type: "text", className: styles.searchInput, placeholder: "\u641C\u7D22\u59D3\u540D\u6216\u90AE\u7BB1...", value: keyword, onChange: e => setKeyword(e.target.value), "data-test-id": "member_search_input" }),
        React.createElement("div", { className: styles.listArea, ref: listRef }, filteredAndSorted.length === 0 ? (React.createElement("div", { className: styles.empty }, "\u65E0\u5339\u914D\u6210\u5458")) : dimensions.height > 0 ? (React.createElement(List, { width: dimensions.width, height: dimensions.height, rowCount: filteredAndSorted.length, rowHeight: ROW_HEIGHT, rowRenderer: rowRenderer, overscanRowCount: OVERSCAN })) : null)));
};
export default FlatMemberView;
